<template>
  <div id="app">
    <div id="getHeader"></div>
    <div>
      <router-view />
    </div>
    <div id="getFooter"></div>
  </div>
</template>
<script>
import $ from "jquery";
import { getHeader, getFooter } from "./common/utils/pageCtents";
export default {
  methods: {
    hoverHabdel() {
      // 适用机型
      $(".submenu").on({
        mouseleave: function () {
          $(this).hide();
        },
      });
      $(".submenu ul li a").on({
        mouseenter: function () {
          $(this).css("color", "#0090E2");
        },
        mouseleave: function () {
          $(this).css("color", "#333");
        },
      });
      $(".first").on({
        mouseenter: function () {
          $(".submenu").hide();
          //   $($(this).parent()).hasClass('hasSub') && $(this).css('padding','0 14px')
          $(this).addClass("check-color");
          if ($(this).next().length > 0) {
            $(this).next().show();
          }
          //   var li = $(this).parent().find(".submenu ul li");
          //   var left = $(this).position().left-$(li).length*75+$(this).width()/2;
          //   $(li).eq(0).css("margin-left",left+"px");
          $(".submenu").css("left", $(this).position().left);
        },
        mouseleave: function () {
          if ($(this).hasClass("clickFlag")) {
            return;
          } else {
            // $(this).css('padding','0 14px')
            $(this).removeClass("check-color");
          }
        },
        click: function () {
          if ($(this).next().length > 0) {
            $(this).next().show();
          }
          $(".clickFlag").removeClass("clickFlag");
          //   $(".check-color").removeClass("check-color");
          //   $(this).addClass("check-color clickFlag");
        },
      });
    },
    async headHandle() {
      let ret = await getHeader();
      document.getElementById("getHeader").innerHTML = ret.data;
    },
    async footerHandle() {
      let ret = await getFooter();
      document.getElementById("getFooter").innerHTML = ret.data;
    },
  },
  async mounted() {
    await this.headHandle();
    await this.footerHandle();
    this.hoverHabdel();
  },
  created() {},
};
</script>
<style lang="less">
/*@import "/api/etc/designs/casch/css/clientlib-header/header.css";*/
/*@import "/api/etc/designs/casch/css/clientlib-footer/footer.css";*/
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
/*#nav {*/
/*padding: 30px;*/
/*a {*/
/*font-weight: bold;*/
/*color: #2c3e50;*/
/*&.router-link-exact-active {*/
/*color: #42b983;*/
/*}*/
/*}*/
/*}*/
</style>
